import { SignUpUserDto, UserDto } from '../utils/types'
import apiClient from './api-client'

export const getSelf = async (): Promise<UserDto> => {
    const res = await apiClient.get('/v1/users/self')
    return res.data
}

export const finalizeSignUp = async (request: SignUpUserDto): Promise<UserDto> => {
    const res = await apiClient.put('/v1/users/self', request)
    return res.data
}

export const deleteMyself = async () => {
    const res = await apiClient.delete('/v1/users/self')
    return res.data
}
